<template>
  <div class="page pda-screen ignore">
    <header-title title="Tag Registration"></header-title>
    <div class="page-body">
      <div class="info-box">
        <van-form
          label-width="40%"
          input-align="right"
          ref="formRef"
          error-message-align="right"
        >
          <van-cell-group class="v-box" v-if="regionCodes.length">
            <van-field
              label="Region Code"
              v-model="option.regionCode"
              placeholder="Please select"
              name="regionCode"
              is-link
              arrow-direction="down"
              @click="showPicker = true"
              readonly
            />
          </van-cell-group>
          <div class="alert-box icon ion-android-alert">
            <i class="icon-box"><ExclamationCircleFilled /></i>
            <div class="en">
              Please scan the tag and choose the signal direction:
            </div>
            <span class="zh">请扫描标签并选择信号方向:</span>
          </div>
          <div
            class="status"
            v-if="implementStauts"
            :class="implementStauts.status ? 'success' : 'dander'"
          >
            <div class="title">{{ implementStauts.msg }}</div>
            <div class="nr" v-if="implementStauts.info">
              {{ implementStauts.info }}
            </div>
          </div>
          <van-cell-group>
            <van-field
              label="Tag Id"
              label-width="30%"
              v-model="inputTagId"
              :readonly="!isManual"
              label-class="vip-label"
              :placeholder="
                isManual ? 'Please enter Tag Id' : 'Please scan Tag Id'
              "
              ref="vipTag"
              name="tagId"
              :error="inputTagId !== '' && !form.id"
              @blur="searchTagId(inputTagId)"
              @keypress.enter="tagIdEnter"
              required
              :rules="[{ required: true, message: 'Tag Id are required' }]"
            >
              <template #button>
                <van-button
                  size="small"
                  @click="isManual = !isManual"
                  :icon="isManual ? 'edit' : 'scan'"
                ></van-button>
              </template>
            </van-field>
            <van-field label="Job Id" v-model="form.jobId" readonly />
            <van-field
              label="Current Region"
              v-model="form.regionCode"
              readonly
            />
            <van-field label="Object Id" v-model="form.objectId" readonly />
            <van-field label="Object Qty" v-model="form.objectQty" readonly />
          </van-cell-group>
        </van-form>
      </div>
    </div>
    <div class="page-footer">
      <a-button type="primary" @click="submitTag(true)">IN</a-button>
      <a-button @click="submitTag(false)">OUT</a-button>
    </div>
    <van-popup v-model:show="showPicker" position="bottom">
      <van-picker
        :columns="regionCodes"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :columns-field-names="customFieldName"
      />
    </van-popup>
    <van-action-sheet
      v-model:show="sheetShow"
      :actions="nObjectIdItems"
      @select="onSheetSelect"
    />
    <van-action-sheet
      v-model:show="objectIdSheetShow"
      :actions="objectIds"
      @select="onObjectIdSelect"
    />
    <van-popup v-model:show="showTagPopup" position="bottom">
      <div style="padding: 20px">
        <van-field
          label="New Tag"
          v-model="newTagId"
          :readonly="!isManual2"
          label-class="vip-label"
          :placeholder="
            isManual2 ? 'Please enter Tag Id' : 'Please scan Tag Id'
          "
          name="newTagId"
        >
          <template #button>
            <van-button
              size="small"
              @click="isManual2 = !isManual2"
              :icon="isManual2 ? 'edit' : 'scan'"
            ></van-button>
          </template>
        </van-field>
        <div style="padding-top: 10px">
          <van-button type="primary" block @click="submitNewTagId">
            Confirm
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
  import HeaderTitle from '@/layout/header-title'
  import { trimAll } from '@/utils'
  import { ref, computed, watchEffect } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'
  import {
    Form as VanForm,
    Field as VanField,
    CellGroup as VanCellGroup,
    button as VanButton,
    Notify,
    Toast,
    Popup as VanPopup,
    picker as VanPicker,
    ActionSheet as VanActionSheet,
    Dialog,
  } from 'vant'
  import { ExclamationCircleFilled } from '@ant-design/icons-vue'
  import request from '@/utils/request'
  const store = useStore()
  const route = useRoute()
  const form = ref({})
  const option = ref({
    regionCode: (route.query && route.query.regionCode) || '',
    objectId: (route.query && route.query.objectId) || '',
  })
  const vipTag = ref(null)
  const implementStauts = ref(null)
  const tagIdEnter = () => {
    vipTag.value.blur()
  }

  const netGroupId = computed(() => store.getters['user/currentNetGroup'])
  // 下拉框相关---------------------------------------------------
  const showPicker = ref(false)
  const regionCodes = ref([])
  const customFieldName = ref({
    text: 'regionCode',
  })
  const getRegionCodeItems = () => {
    Toast.loading({
      message: 'Loading...',
      forbidClick: true,
      duration: 0,
    })
    request({
      url: '/api/scan/getScanRegionList',
      method: 'get',
      params: {
        netGrpId: netGroupId.value,
      },
    })
      .then((res) => {
        regionCodes.value = res.body
        const { regionCode } = route.query
        option.value.regionCode = regionCode
          ? regionCode
          : res.body.length
          ? res.body[0].regionCode
          : ''
      })
      .finally(() => {
        Toast.clear()
      })
  }
  getRegionCodeItems()

  const onConfirm = (value) => {
    if (typeof value === 'object') {
      option.value.regionCode = value.regionCode
    } else {
      option.value.regionCode = value
    }

    showPicker.value = false
  }
  // end ---------------------------------------------------
  const searchTagId = (v) => {
    if (v || inputTagId.value) {
      if (v) {
        implementStauts.value = null
      }
      Toast.loading({
        message: 'Loading...',
        forbidClick: true,
        duration: 0,
      })
      request({
        url: '/api/workstation/getUBByTagId',
        method: 'get',
        nonstandard: true,
        params: {
          tagId: v || inputTagId.value,
          regionCode: option.value.regionCode,
        },
      })
        .then((res) => {
          if (res.errCode === '0000') {
            if (res.body) {
              form.value = res.body
            } else {
              form.value = {}
            }
          } else {
            form.value = {}
          }
        })
        .finally(() => {
          Toast.clear()
        })
    }
  }

  // tagId 扫描---------------------------------------------------
  const inputTagId = ref('')
  const isManual = ref(false)
  const isManual2 = ref(false)
  // 监听扫码输入
  const watchScanInput = () => {
    var keyStr = ''
    var lastTime = null
    var nextTime = null
    var lastCode = null

    document.onkeydown = function (e) {
      console.log(e.key)
      //获取当前时间
      nextTime = new Date().getTime()
      if (e.key == 'Enter' || e.key === 'F8') {
        //回车字符
        if (keyStr != '' && nextTime - lastTime <= 30) {
          if (showTagPopup.value) {
            newTagId.value = trimAll(keyStr, 'g')
          } else {
            inputTagId.value = trimAll(keyStr, 'g') // mht
          }

          searchTagId(keyStr)
          keyStr = ''
          lastCode = null
          lastTime = null
        }
      } else if (e.key.length === 1) {
        if (lastCode == null && lastTime == null) {
          //初始字母
          keyStr = e.key
        } else if (
          lastCode != null &&
          lastTime != null &&
          nextTime - lastTime <= 30
        ) {
          keyStr += e.key
        } else {
          //手动输入
          keyStr = ''
          lastCode = null
          lastTime = null
        }
        lastCode = e.key
        lastTime = nextTime
      }
    }
  }
  watchScanInput()
  // end ---------------------------------------------------
  // start IN && OUT---------------------------------------------------
  const regionTypeIsFF = ref(!!route.query.objectId)
  const onObjectIdSelect = (item) => {
    option.value.objectId = item.name
    objectIdSheetShow.value = false
    insertUWBBinding()
  }
  const objectIds = ref([])
  const objectIdSheetShow = ref(false)
  const getObjectIdItems = (callback) => {
    Toast.loading({
      message: 'Loading...',
      forbidClick: true,
      duration: 0,
    })
    request({
      url: 'api/scan/getFFRegionObjectList',
      method: 'get',
      nonstandard: true,
      params: {
        regionCode: option.value.regionCode,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          objectIds.value = res.body.map((item) => {
            return { name: item }
          })
          option.value.objectId =
            route.query && route.query.objectId
              ? route.query.objectId
              : res.body[0].objectId
          callback()
        }
      })
      .finally(() => {
        Toast.clear()
      })
  }
  watchEffect(() => {
    if (option.value.regionCode && regionCodes.value.length) {
      let regionType = regionCodes.value.find(
        (element) => element.regionCode == option.value.regionCode
      ).regionType
      regionTypeIsFF.value = regionType === 'FF'
    }
  })
  // 提交
  const submitTag = function (type) {
    if (!inputTagId.value) {
      implementStauts.value = {
        msg: type ? 'IN' : 'OUT',
        status: false,
        info: 'TagId不能为空',
      }
      return false
    }
    if (regionTypeIsFF.value) {
      if (type) {
        //IN
        if (form.value.id) {
          preCheckIn(true, true)
        } else {
          getObjectIdItems(() => {
            objectIdSheetShow.value = true
          })
        }
      } else {
        // OUT
        Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          duration: 0,
        })
        try {
          checkoutFifoOutRegionInKanbanGroup(function () {
            if (!form.value.skipSwitch) {
              _replaceTagId()
            } else {
              preCheckOut()
            }
          })
        } catch (e) {
          Toast.clear()
        }
      }
    } else if (form.value.id) {
      submitScan(type)
    } else {
      Notify({
        type: 'danger',
        message: '标签未注册！',
      })
    }
  }
  const _checkObjectId = (callback) => {
    request({
      url: 'api/uwb/checkObjectId',
      method: 'get',
      params: {
        regionCode: option.value.regionCode,
        tagId: inputTagId.value,
      },
    }).then((res) => {
      if (res.errCode === '0000') {
        callback(res.body)
      }
    })
  }
  const nObjectIdItems = ref([])
  const sheetShow = ref(false)
  const operationType = ref(false)
  const onSheetSelect = (item) => {
    _updateUwbBinding(item.name, operationType.value)
  }
  const preCheckIn = (type, runCheckObjectId) => {
    Toast.loading({
      message: 'Loading...',
      forbidClick: true,
      duration: 0,
    })
    request({
      url: 'api/scan/preCheckIn',
      method: 'get',
      nonstandard: true,
      params: {
        regionCode: option.value.regionCode,
        tagId: inputTagId.value,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          _checkObjectId(function (arr) {
            if (arr && arr.length > 1 && runCheckObjectId) {
              nObjectIdItems.value = arr.map((item) => {
                return { name: item }
              })
              sheetShow.value = true
              operationType.value = type
            } else if (arr && arr.length === 1 && runCheckObjectId) {
              _updateUwbBinding(arr[0], type)
            } else {
              if (res.body.statusCode === 0) {
                submitScan(type)
              } else if (res.body.statusCode === 1) {
                scanInConsume(res.body.matransit)
              } else if (res.body.statusCode === 2) {
                showTagPopup.value = true
                matransit.value = res.body.matransit
              }
            }
          })
        } else {
          implementStauts.value = {
            msg: 'IN',
            status: false,
            info: res.errMsg.replace(/<br>/g, '\n'),
          }
        }
      })
      .finally(() => {
        Toast.clear()
      })
  }
  const _updateUwbBinding = (objectId, type) => {
    request({
      url: '/api/uwb/updateUwbBinding',
      method: 'get',
      nonstandard: true,
      params: {
        tagId: inputTagId.value,
        objectId,
      },
    }).then((res) => {
      if (res.errCode === '0000') {
        submitScan(type)
      } else {
        implementStauts.value = {
          msg: 'IN',
          status: false,
          info: res.errMsg.replace(/<br>/g, '\n'),
        }
      }
    })
  }
  const submitScan = (type) => {
    Toast.loading({
      message: 'Loading...',
      forbidClick: true,
      duration: 0,
    })
    request({
      url: 'api/scan/scan',
      method: 'post',
      data: {
        fromRegionId: type ? 'NA' : option.value.regionCode,
        moving: true,
        tag: inputTagId.value,
        toRegionId: type ? option.value.regionCode : 'NA',
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          Notify({ type: 'success', message: 'Success' })

          implementStauts.value = {
            msg: type ? 'IN' : 'OUT',
            status: true,
          }
          searchTagId()
        } else {
          implementStauts.value = {
            msg: type ? 'IN' : 'OUT',
            status: false,
            info: res.errMsg.replace(/<br>/g, '\n'),
          }
          searchTagId()
        }
      })
      .finally(() => {
        Toast.clear()
      })
  }
  const scanInConsume = (data, tagId) => {
    if (data.tagId === tagId) {
      Dialog.alert({
        message: '入库"Tag Id"与Vendor "Tag Id"不能相同.',
      })
      return
    }
    request({
      url: 'api/scan/scanInConsume',
      method: 'post',
      nonstandard: true,
      params: {
        fromRegionCode: option.value.regionCode,
        tagId: tagId ? tagId : inputTagId.value,
        objectId: option.value.objectId || data.objectId,
      },
      data: {
        fromRegionId: data.fromRegionCode,
        moving: true,
        tag: data.tagId,
        timestamp: 0,
        toRegionId: data.toRegionCode,
        x: 0,
        y: 0,
      },
    }).then((res) => {
      if (res.errCode === '0000') {
        Notify({ type: 'success', message: 'Success' })
        implementStauts.value = {
          msg: 'IN',
          status: true,
        }
        searchTagId()
      } else {
        implementStauts.value = {
          msg: 'IN',
          status: false,
          info: res.errMsg.replace(/<br>/g, '\n'),
        }
        searchTagId()
      }
    })
  }
  //新tagId
  const newTagId = ref('')
  const tagPopupType = ref('')
  const showTagPopup = ref(false)
  const matransit = ref(null)
  const submitNewTagId = () => {
    if (tagPopupType.value === 'out') {
      request({
        url: 'api/scan/preCheckOut',
        method: 'get',
        nonstandard: true,
        params: {
          regionCode: option.value.regionCode,
          tagId: newTagId.value,
        },
      }).then((res) => {
        if (res.errCode === '0000') {
          __scanFifoOut()
        } else {
          Notify({ type: 'warning', message: res.errMsg })
          implementStauts.value = {
            msg: 'OUT',
            status: false,
            info: res.errMsg.replace(/<br>/g, '\n'),
          }
        }
      })
    } else {
      scanInConsume(matransit.value, newTagId.value)
    }

    showTagPopup.value = false
  }
  const checkoutFifoOutRegionInKanbanGroup = (callback) => {
    request({
      url: 'api/scan/checkoutFifoOutRegionInKanbanGroup',
      method: 'get',
      nonstandard: true,
      params: {
        regionCode: option.value.regionCode,
        tagId: inputTagId.value,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          callback()
        } else {
          implementStauts.value = {
            msg: 'OUT',
            status: false,
            info: res.errMsg.replace(/<br>/g, '\n'),
          }
        }
      })
      .finally(() => {
        Toast.clear()
      })
  }
  const _replaceTagId = () => {
    showTagPopup.value = true
    tagPopupType.value = 'out'
  }
  const __scanFifoOut = () => {
    request({
      url: 'api/scan/scanFifoOut',
      method: 'post',
      nonstandard: true,
      params: {
        oldTagId: newTagId.value,
      },
      data: {
        fromRegionId: option.value.regionCode,
        moving: true,
        tag: inputTagId.value,
        toRegionId: 'NA',
      },
    }).then((res) => {
      if (res.errCode === '0000') {
        Notify({ type: 'success', message: 'Success' })

        implementStauts.value = {
          msg: 'OUT',
          status: true,
        }
        searchTagId()
      } else {
        implementStauts.value = {
          msg: 'OUT',
          status: false,
          info: res.errMsg.replace(/<br>/g, '\n'),
        }
      }
    })
  }
  const preCheckOut = () => {
    request({
      url: 'api/scan/preCheckOut',
      method: 'get',
      nonstandard: true,
      params: {
        regionCode: option.value.regionCode,
        tagId: inputTagId.value,
      },
    })
      .then((res) => {
        if (res.errCode === '0000') {
          submitScan(false)
        } else {
          implementStauts.value = {
            msg: 'OUT',
            status: false,
            info: res.errMsg.replace(/<br>/g, '\n'),
          }
        }
      })
      .finally(() => {
        Toast.clear()
      })
  }
  const insertUWBBinding = () => {
    request({
      url: 'api/scan/insertUWBBindingByTagIdObjectId',
      method: 'post',
      nonstandard: true,
      params: {
        tagId: inputTagId.value,
        objectId: option.value.objectId,
      },
    }).then((res) => {
      if (res.errCode === '0000') {
        preCheckIn(true, true)
      } else {
        implementStauts.value = {
          msg: 'IN',
          status: false,
          info: res.errMsg.replace(/<br>/g, '\n'),
        }
      }
    })
  }
  // end IN && OUT---------------------------------------------------
</script>

<style lang="less" scoped>
  @import 'scan.less';
</style>
